package com.trevorwiebe.timesheet.core.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GeocodeResponseDto(
    val status: String = "",
    val results: List<GeocodeResultDto> = emptyList(),
    @SerialName("error_message") val errorMessage: String? = null
)

@Serializable
data class GeocodeResultDto(
    @SerialName("formatted_address") val formattedAddress: String = "",
    val geometry: GeometryDto
)

@Serializable
data class GeometryDto(
    val location: LatLngDto
)

@Serializable
data class LatLngDto(
    val lat: Double,
    val lng: Double
)
